/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum APPLICATION_EVENTS {
	'PRE_UPDATE' = 'pre_update',
	'UPDATE' = 'update',
	'POST_UPDATE' = 'post_update',
	'DRAW' = 'draw',
	'UPDATE_DATA' = 'updateData',
	'DESTROY' = 'destroy',
	'DESTROY_TICKET' = 'destroyTicket',
}
